import Delta3Series from '@elem/compPage/Delta3Series';
import { IPageStatus } from '@elem/compPage/Delta3Series/config/IPageStatus';
import { ProductProvider } from 'elem/compPage/Delta3Series/ProductProvider';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { redirectTo404 } from '@/utils';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';

const whiteLocaleList = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'nl', 'jp', 'br', 'mx', 'ph'];
const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd'; //是否是生产环境
export default function Page({ SEO, lang, timeLine, pageStatus, systemTime }: any) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('delta3series');
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const initState = {
        systemTime: systemTime,
        pageStatus: pageStatus,
        timeLine: timeLine,
        productTabActive: 'Product',
    };

    return (
        <>
            <PageLayout isNoFixed={true}>
                <SEO title={lang.seo_title || t('seo_title')} description={lang.seo_desc || t('seo_desc')} />
                <SEOlinksA locale={locale} list={whiteLocaleList} pathname={'delta-3-series-portable-power-station'} />
                <GtmPageLoad />
                <ProductProvider state={initState}>
                    <Delta3Series />
                </ProductProvider>
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale, req, query }: GetServerSidePropsContext) {
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/Delta3Series/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/Delta3Series/config/times/jp.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }
    // 当前页面阶段
    let pageStatus = IPageStatus.statusA;
    if (debug) {
        // 是否进入调试状态
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusD?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusD;
        } else if (systemTime >= timeLine?.statusC?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            // 系统时间进入 statusB 时间段
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        } else if (isPrd) {
            // 系统时间不在上述时间段,且进入生产环境才跳转404
            return redirectTo404();
        }
    }
    return {
        props: {
            systemTime,
            timeLine: timeLine,
            debug: debug || '',
            pageStatus: pageStatus,
        },
    };
}
